// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1D0ns","title":"styles_title__37H3S"};